'use client'

import type { Ref } from 'react'
import type { BaseSelectRef } from 'rc-select'
import { Select as AntSelect } from 'antd'
import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'
import type { T_SelectProps } from './select'


export const SC_SelectWrapper = styled.div`
  width: 100%;

  .ant-select {
    width: 100%;
    height: 60px;
  }

  .ant-select-selector {
    padding: 0 16px !important;
    background-color: ${E_Colors.White} !important;
    border: 1.5px solid transparent !important;
    border-radius: 24px;
    color: ${E_Colors.TextPrimary} !important;
    font-size: 16px;
  }

  .ant-select.ant-select-open .ant-select-selector,
  .ant-select.ant-select-focused .ant-select-selector {
    border-color: #9E6DEA !important;
    box-shadow: none !important;

    .ant-select-selection-item {
      color: ${E_Colors.TextPrimary} !important;
    }
  }

  .ant-select-dropdown {
    border-radius: 24px;
    border: 1px solid red !important;
  }
`

export const SC_Select = styled(
  (p: T_SelectProps & {
    setFormValue: (key: string, value: string) => void
    selectRef?: Ref<BaseSelectRef>
  }) => {
    const {
      setFormValue,
      selectRef,
      ...restProps
    } = p


    return (
      <AntSelect
        {...restProps}
        onChange={(value: string) => setFormValue(p.name, value)}
        ref={selectRef}
      />
    )
  }
)`
  ${(p) => p.$minWidth ? `min-width: ${p.$minWidth}` : ''};
  ${(p) => p.$isBordered ? `
    border: 1px solid ${E_Colors.GrayE3};
    border-radius: 8px;
  ` : ''}

`
